import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { ClaseAusentismo } from '../models/claseAusentismo';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/ClaseAusentismos';

@Injectable({
  providedIn: 'root'
})
export class ClaseAusentismoService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' });
  }

  save(entidad: ClaseAusentismo)
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }
}
